import { jsx as e, jsxs as i } from "react/jsx-runtime";
import { createContext as u, useState as m, useEffect as g, useContext as w } from "react";
function p() {
  return !!(localStorage.theme === "dark" || !("theme" in localStorage) && window.matchMedia("(prefers-color-scheme: dark)").matches);
}
const h = u({
  darkModeProviderInstalled: !1,
  theme: "light",
  changeTheme: (r) => {
    console.log("Changing theme", r);
  }
});
function b(r) {
  const [a, n] = m(
    p() ? "dark" : "light"
  );
  function l(t) {
    n(t), localStorage.theme = t;
  }
  return g(() => {
    var t, o;
    switch (a) {
      case "light":
        (t = document.body.parentElement) == null || t.classList.remove("dark");
        break;
      case "dark":
      default:
        (o = document.body.parentElement) == null || o.classList.add("dark");
        break;
    }
  }, [a]), /* @__PURE__ */ e(
    h.Provider,
    {
      value: { darkModeProviderInstalled: !0, theme: a, changeTheme: l },
      children: r.children
    }
  );
}
const f = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e("path", { d: "M9.34484 17.0626C9.21734 17.0626 9.08984 17.0626 8.96234 17.0551C4.76234 16.8676 1.25234 13.4851 0.959839 9.36009C0.704839 5.82009 2.75234 2.51259 6.05234 1.12509C6.98984 0.735086 7.48484 1.03509 7.69484 1.25259C7.90484 1.46259 8.19734 1.95009 7.80734 2.84259C7.46234 3.63759 7.28984 4.48509 7.29734 5.35509C7.31234 8.67759 10.0723 11.4976 13.4398 11.6326C13.9273 11.6551 14.4073 11.6176 14.8723 11.5351C15.8623 11.3551 16.2748 11.7526 16.4323 12.0076C16.5898 12.2626 16.7698 12.8101 16.1698 13.6201C14.5798 15.7951 12.0523 17.0626 9.34484 17.0626ZM2.07734 9.27759C2.33234 12.8476 5.37734 15.7726 9.00734 15.9301C11.4748 16.0501 13.8148 14.9251 15.2548 12.9601C15.3673 12.8026 15.4198 12.6901 15.4423 12.6301C15.3748 12.6226 15.2548 12.6151 15.0673 12.6526C14.5198 12.7501 13.9498 12.7876 13.3873 12.7651C9.42734 12.6076 6.18734 9.28509 6.16484 5.37009C6.16484 4.33509 6.36734 3.33759 6.77984 2.40009C6.85484 2.23509 6.86984 2.12259 6.87734 2.06259C6.80984 2.06259 6.68984 2.07759 6.49484 2.16009C3.63734 3.36009 1.86734 6.22509 2.07734 9.27759Z" })
  }
), k = () => /* @__PURE__ */ i(
  "svg",
  {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9 4.6875C6.61827 4.6875 4.6875 6.61827 4.6875 9C4.6875 11.3817 6.61827 13.3125 9 13.3125C11.3817 13.3125 13.3125 11.3817 13.3125 9C13.3125 6.61827 11.3817 4.6875 9 4.6875ZM3.5625 9C3.5625 5.99695 5.99695 3.5625 9 3.5625C12.003 3.5625 14.4375 5.99695 14.4375 9C14.4375 12.003 12.003 14.4375 9 14.4375C5.99695 14.4375 3.5625 12.003 3.5625 9Z"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9 0.75C9.41421 0.75 9.75 1.08579 9.75 1.5V1.56C9.75 1.97421 9.41421 2.31 9 2.31C8.58579 2.31 8.25 1.97421 8.25 1.56V1.5C8.25 1.08579 8.58579 0.75 9 0.75ZM3.11467 3.11467C3.40756 2.82178 3.88244 2.82178 4.17533 3.11467L4.27283 3.21217C4.56572 3.50506 4.56572 3.97994 4.27283 4.27283C3.97994 4.56572 3.50506 4.56572 3.21217 4.27283L3.11467 4.17533C2.82178 3.88244 2.82178 3.40756 3.11467 3.11467ZM14.8853 3.11467C15.1782 3.40756 15.1782 3.88244 14.8853 4.17533L14.7878 4.27283C14.4949 4.56572 14.0201 4.56572 13.7272 4.27283C13.4343 3.97994 13.4343 3.50506 13.7272 3.21217L13.8247 3.11467C14.1176 2.82178 14.5924 2.82178 14.8853 3.11467ZM0.75 9C0.75 8.58579 1.08579 8.25 1.5 8.25H1.56C1.97421 8.25 2.31 8.58579 2.31 9C2.31 9.41421 1.97421 9.75 1.56 9.75H1.5C1.08579 9.75 0.75 9.41421 0.75 9ZM15.69 9C15.69 8.58579 16.0258 8.25 16.44 8.25H16.5C16.9142 8.25 17.25 8.58579 17.25 9C17.25 9.41421 16.9142 9.75 16.5 9.75H16.44C16.0258 9.75 15.69 9.41421 15.69 9ZM4.27283 13.7272C4.56572 14.0201 4.56572 14.4949 4.27283 14.7878L4.17533 14.8853C3.88244 15.1782 3.40756 15.1782 3.11467 14.8853C2.82178 14.5924 2.82178 14.1176 3.11467 13.8247L3.21217 13.7272C3.50506 13.4343 3.97994 13.4343 4.27283 13.7272ZM13.7272 13.7272C14.0201 13.4343 14.4949 13.4343 14.7878 13.7272L14.8853 13.8247C15.1782 14.1176 15.1782 14.5924 14.8853 14.8853C14.5924 15.1782 14.1176 15.1782 13.8247 14.8853L13.7272 14.7878C13.4343 14.4949 13.4343 14.0201 13.7272 13.7272ZM9 15.69C9.41421 15.69 9.75 16.0258 9.75 16.44V16.5C9.75 16.9142 9.41421 17.25 9 17.25C8.58579 17.25 8.25 16.9142 8.25 16.5V16.44C8.25 16.0258 8.58579 15.69 9 15.69Z"
        }
      )
    ]
  }
);
function y() {
  const { theme: r, darkModeProviderInstalled: a, changeTheme: n } = w(h), l = "bottom-0 h-4 my-0 top-1 absolute transition-opacity w-3 ";
  let t = "flex items-center justify-center w-4 h-4";
  a || console.error(
    "You are trying to use a dark mode switch, but <DarkModeProvider /> is not installed in your <App />."
  );
  let o = "left-1", d = "opacity-0", s = "opacity-100", c = "bg-gray-200", C = "bg-neutral-600";
  return r == "dark" && (o = "right-1", d = "opacity-100", s = "opacity-0", c = "bg-neutral-600", C = "bg-white", t += " text-white"), /* @__PURE__ */ i(
    "div",
    {
      className: "relative w-12 cursor-pointer user-select-none",
      onClick: () => n(r == "dark" ? "light" : "dark"),
      children: [
        /* @__PURE__ */ i(
          "div",
          {
            className: "w-12 h-6 transition-all  rounded-full " + c,
            role: "button",
            children: [
              /* @__PURE__ */ e(
                "div",
                {
                  className: l + " left-1 text-white  " + d,
                  children: /* @__PURE__ */ e("span", { className: t, children: /* @__PURE__ */ e(f, {}) })
                }
              ),
              /* @__PURE__ */ e("div", { className: l + " right-2 " + s, children: /* @__PURE__ */ e("span", { className: t, children: /* @__PURE__ */ e(k, {}) }) }),
              /* @__PURE__ */ e(
                "div",
                {
                  className: "absolute transition-all w-4 h-4 rounded-full  top-1 " + o + " " + C
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ e(
          "input",
          {
            readOnly: !0,
            type: "checkbox",
            checked: r == "dark",
            className: "absolute w-0 h-0 m-0 overflow-hidden border-0",
            "aria-label": "Switch between dark and light mode"
          }
        )
      ]
    }
  );
}
export {
  h as D,
  b as a,
  y as b
};
